/* ============================================================
   LeatherFurniture.com — In-Stock Grade Panel  (v1.3)
   IN STOCK (blue panel, white option boxes) + MADE TO ORDER.
   Display-only; never touches variants or swatch logic.
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------- CONFIG -------------------------- */

  var BLUE = '#6E96AC';

  var LABEL_MAP = {
    'tan stock': 'Tan Leather',
    'brown stock': 'Brown Leather'
  };

  var STOCK_HEADER = 'IN STOCK';
  var STOCK_SUB = 'Ready to ship \u2014 no custom lead time.';
  var CUSTOM_HEADER = 'MADE TO ORDER';
  var CUSTOM_SUB = 'Customize your choice of leather grade and color.';

  /* ---------------------------------------------------------- */

  function init() {
    var sections = document.querySelectorAll('section.select-grade');
    if (!sections.length) return;

    var builtAny = false;

    sections.forEach(function (section) {
      var origUl = section.querySelector('ul[rv-active-grade]');
      if (!origUl) return;
      if (section.querySelector('.lf-stock-panel')) return;

      var stockLis = Array.prototype.filter.call(
        origUl.querySelectorAll('li'),
        function (li) {
          return (li.getAttribute('data-grade') || '')
            .toLowerCase()
            .indexOf('stock') !== -1;
        }
      );
      if (!stockLis.length) return;

      var panel = document.createElement('div');
      panel.className = 'lf-stock-panel';
      panel.style.cssText =
        'background:' + BLUE + ';border-radius:8px;' +
        'padding:20px 30px 25px;margin:15px 0 25px;' +
        'width:fit-content;text-align:center;';

      var header = document.createElement('h2');
      header.textContent = STOCK_HEADER;
      header.style.cssText =
       'font-weight:750;letter-spacing:1px;margin:0 0 4px;color:#fff;';

      var sub = document.createElement('p');
      sub.textContent = STOCK_SUB;
      sub.style.cssText =
        'color:rgba(255,255,255,0.85);font-size:14px;margin:0 0 15px;';

      var stockUl = document.createElement('ul');
      stockUl.className = 'lf-stock-list';
      stockUl.style.cssText =
        'display:flex;gap:20px;list-style:none;margin:0;padding:0;' +
        'justify-content:center;';

      panel.appendChild(header);
      panel.appendChild(sub);
      panel.appendChild(stockUl);
      origUl.parentNode.insertBefore(panel, origUl);

      var customHeader = document.createElement('h2');
      customHeader.textContent = CUSTOM_HEADER;
      customHeader.style.cssText =
        'font-weight:750;letter-spacing:1px;margin:0 0 4px;';

      var customSub = document.createElement('p');
      customSub.textContent = CUSTOM_SUB;
      customSub.style.cssText = 'color:#666;font-size:14px;margin:0 0 12px;';

      origUl.parentNode.insertBefore(customHeader, origUl);
      origUl.parentNode.insertBefore(customSub, origUl);

      stockLis.forEach(function (li) {
        stockUl.appendChild(li);

        var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT);
        var toClear = [];
        var node;
        while ((node = walker.nextNode())) {
          var key = node.textContent.trim().toLowerCase();
          if (LABEL_MAP[key]) {
            node.textContent = LABEL_MAP[key];
          } else if (key === 'grade') {
            toClear.push(node);
          }
        }
        toClear.forEach(function (n) { n.textContent = ''; });
      });

      var allLis = Array.prototype.slice
        .call(stockUl.querySelectorAll('li'))
        .concat(Array.prototype.slice.call(origUl.querySelectorAll('li')));

      allLis.forEach(function (li) {
        li.addEventListener('click', function () {
          stockUl.querySelectorAll('li').forEach(function (s) {
            s.setAttribute('data-active', s === li ? 'true' : 'false');
          });
        });
      });

      builtAny = true;
    });

    if (builtAny && !document.getElementById('lf-stock-styles')) {
      var style = document.createElement('style');
      style.id = 'lf-stock-styles';
      style.textContent =
        /* white option boxes, white text, centered content */
        'div.lf-stock-panel ul.lf-stock-list.lf-stock-list li{' +
        'background:#fff!important;background-color:#fff!important;' +
        'border-radius:4px;box-shadow:none!important;' +
        'color:#000!important;padding:15px 20px!important;' +
        'margin:0!important;width:auto!important;min-width:110px;' +
        'min-height:0!important;cursor:pointer;' +
        'display:flex!important;flex-direction:column!important;' +
        'align-items:center!important;justify-content:center!important;' +
        'text-align:center!important;float:none!important;}' +
        /* children: white text, and pull the circle back into the
           centered flow (mobile theme absolutely-positions it) */
        'div.lf-stock-panel ul.lf-stock-list.lf-stock-list li *{' +
        'color:#000!important;' +
        'position:static!important;' +
        'float:none!important;' +
        'margin-left:auto!important;margin-right:auto!important;' +
        'transform:none!important;}';
      document.head.appendChild(style);
    }
  }

  /* Rivets renders the grade boxes after load — poll until ready. */
  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;
    var lis = document.querySelectorAll(
      'section.select-grade ul[rv-active-grade] li'
    );
    if (lis.length) {
      clearInterval(poll);
      init();
    } else if (attempts > 40) {
      clearInterval(poll);
    }
  }, 250);
})();